import {EBreakpoint} from '@/common/scripts/constants';
import Observer from '@/common/scripts/observer';
import {Utils} from '@/common/scripts/utils';

const observer = new Observer();

class ParametricFilterPopup {
    constructor(element) {
        this.element = element;

        /**
         * CSS-класс открытого попапа
         * @type {string}
         */
        this.openClass = 'is-open';

        /**
         * CSS-класс закрывающегося попапа
         * @type {string}
         */
        this.closeClass = 'is-close';

        /**
         * Состояние открыт или нет (мобильный попап)
         * @type {boolean}
         */
        this.isOpen = false;

        this.isMobile = Utils.getWindowWidth() < EBreakpoint.TABLET;
    }

    init() {
        if (!this.element) {
            return;
        }

        this._toggleFix = this._toggleFix.bind(this);
        this._initElements();
        this._bindEvents();
        this._subscribe();
    }

    _setIsMobile() {
        this.isMobile = Utils.getWindowWidth() < EBreakpoint.TABLET;
    }

    /**
     * Инит элементов
     * @private
     */
    _initElements() {
        this.toggle = Array.from(document.querySelectorAll('.j-parametric-filter__toggle'));
        this.content = this.element.querySelector('.j-parametric-filter__content');
    }

    _subscribe() {
        observer.subscribe('custom-select:close', () => {
            if (this.isMobile && this.isOpen) {
                Utils.bodyFixed(this.element);
            }
        });

        observer.subscribe('parametric-popup-content:close', () => {
            if (this.isOpen) {
                Utils.bodyFixed(this.element);
            }
        });
    }

    /**
     * Вешает обработчики событий
     * @private
     */
    _bindEvents() {
        this.toggle.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                const method = this.isOpen ? 'close' : 'open';

                this[method]();
            });
        });

        this.element.addEventListener('click', (event) => {
            const withinBoundaries = event.composedPath().includes(this.content);

            if (!withinBoundaries) {
                const method = this.isOpen ? 'close' : 'open';

                this[method]();
            }
        });

        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, () => {
                this._setIsMobile();
            });
        });
    }

    /**
    * Открывает попап
    */
    open() {
        Utils.bodyFixed(this.element);
        this.isOpen = true;
        this.element.classList.add(this.openClass);
        this._bindResize();
    }

    /**
     * Закрывает попап
     * @param {boolean} delay - true - есть задержка для анимации
     */
    close(delay = true) {
        if (!this.isOpen) {
            return;
        }

        this.element.classList.add(this.closeClass);

        if (delay) {
            const delayTime = 300;

            setTimeout(() => {
                this._removePopup();
            }, delayTime);
        } else {
            this._removePopup();
        }

        this.isOpen = false;
        this.element.classList.remove(this.openClass);
    }

    /**
     * Удаляет попап, все обработчики и классы
     * @private
     */
    _removePopup() {
        Utils.bodyStatic();
        this.isOpen = false;
        this.element.classList.remove(this.openClass, this.closeClass);
        this._unbindResize();
    }

    /**
     * Вешает обработчики на резайз и изменение ориентации
     * @private
     */
    _bindResize() {
        window.addEventListener('resize', this._toggleFix);
        window.addEventListener('orientationchange', this._toggleFix);
    }

    /**
     * Снимает ресайз-обработчики
     * @private
     */
    _unbindResize() {
        window.removeEventListener('resize', this._toggleFix);
        window.removeEventListener('orientationchange', this._toggleFix);
    }

    /**
     * Переключает фиксацию страницы
     * @private
     */
    _toggleFix() {
        if (!this.isMobile && this.isOpen) {
            this.close(false);
        }
    }
}

export default ParametricFilterPopup;
